import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PublicRoutes from "./PublicRoutes";
import AdminRoutes from "./AdminRoutes";
import PrintTicketsPage from "@/pages/print/PrintTicketsPage";
import PrintFactsPage from "@/pages/print/PrintFactsPage";
import PrintClaimPage from "@/pages/print/PrintClaimPage";
import OwnerDashboard from "@/pages/admin/OwnerDashboard";
import OwnerLoginPage from "@/pages/admin/OwnerLoginPage";

// Generic 404 component to hide admin routes from unauthorized users
const NotFoundPage = () => (
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    height: '100vh',
    background: '#1a1a1a',
    color: '#666'
  }}>
    <div style={{ textAlign: 'center' }}>
      <h1 style={{ fontSize: '72px', margin: 0, color: '#333' }}>404</h1>
      <p style={{ fontSize: '14px' }}>Page not found</p>
    </div>
  </div>
);

const AppRoutes = () => (
  <Routes>
    {/* Print routes (no layout wrapper) */}
    <Route path="/print/tickets" element={<PrintTicketsPage />} />
    <Route path="/print/tickets/:section" element={<PrintTicketsPage />} />
    <Route path="/print/facts/:slug" element={<PrintFactsPage />} />
    <Route path="/print/claim/:id" element={<PrintClaimPage />} />
    
    {/* Hidden management login - only accessible via /manage */}
    <Route path="/manage" element={<OwnerLoginPage />} />
    
    {/* Owner Dashboard routes (protected - requires valid owner session) */}
    <Route path="/owner-dashboard/*" element={<OwnerDashboard />} />
    
    {/* Legacy routes return 404 to hide admin existence */}
    <Route path="/owner-login" element={<NotFoundPage />} />
    <Route path="/login" element={<NotFoundPage />} />
    <Route path="/register" element={<NotFoundPage />} />
    <Route path="/signup" element={<NotFoundPage />} />
    <Route path="/admin/*" element={<NotFoundPage />} />
    
    {/* Public routes */}
    <Route path="/*" element={<PublicRoutes />} />
  </Routes>
);

export default AppRoutes;
